import { ca } from '@cian/analytics';
import { createGaUser, createLabel } from '../../utils/analytics';
import { ECallbackPlace, ICallbackParams } from '../../types/callback';
import { IUser } from '../../types/user/user';
import { DEVELOPER_ID } from '../../constants';

export function trackSendCallbackRequest(
  place: ECallbackPlace,
  { customerPhone, callRightNow, time }: ICallbackParams,
  user: IUser,
) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CardBuilder',
    action: `CallBack_popup_send_${place}`,
    label: createLabel(DEVELOPER_ID),
    useLastProducts: true,
    user: {
      ...createGaUser(user),
      extra: {
        phone: customerPhone,
        call_time: time,
        call_now: callRightNow,
      },
    },
  });
}

export function trackCallbackPopupOpen(place: ECallbackPlace) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CardBuilder',
    action: `CallBack_popup_open_${place}`,
    label: createLabel(DEVELOPER_ID),
    useLastProducts: true,
  });
}
